import { render } from "./index.vue?vue&type=template&id=2ef74936"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/tester_types/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ef74936"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ef74936', __exports__)) {
    console.log('reload')
    api.reload('2ef74936', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2ef74936", () => {
    console.log('re-render')
    api.rerender('2ef74936', render)
  })

}


export default __exports__